<template>
  <div v-if="!isLoading" class="select-limit">
    <LimitOptions
      :limits="formattedLimits"
      @limit-selected="setLimit"
      @limit-switch="onLimitSwitch"
    >
      <template #btn-text>
        {{ $t`Уменьшить лимит` }}
      </template>
    </LimitOptions>
    <CommonButton
      v-if="routeSrc === 'close'"
      class="reject-btn"
      spaced
      flat
      @click="redirectToClose"
    >
      {{ $t`Отказаться и закрыть Kaspi Red` }}
    </CommonButton>
  </div>
</template>

<script>
import {
  getLimitsInsteadClosing,
  setLimitInsteadClosing,
  getDetailsOnClose,
} from "@/api/close";
import LimitOptions from "@/components/limits/LimitOptions.vue";
import CommonButton from "@/components/shared/button/CommonButton.vue";

export default {
  components: {
    LimitOptions,
    CommonButton,
  },
  data() {
    return {
      isLoading: true,
      limits: [],
      selectedLimit: 0,
    };
  },
  async created() {
    // При рероуте на эту страницу нужно в пути всегда в query параметрах
    // указывать с какой страницы произошел редирект (для аналитики)
    if (this.routeSrc) {
      this.$logAnalyticEvent("mybank_red_reduce_limit", {
        page_path: "/bank/red/reduce-limit",
        where: this.routeSrc,
        started_from: "",
      });
    }

    try {
      const limits = await getLimitsInsteadClosing();

      if (limits?.length === 0) {
        this.$router.back();
        return;
      }

      this.limits = limits;
      this.isLoading = false;
    } catch {
      this.$router.back();
    }
  },
  computed: {
    formattedLimits() {
      if (!this.limits) return [];
      return this.limits.map((limit) => this.$currencyFormatter(limit));
    },
    routeSrc() {
      return this.$route.query.src;
    },
  },
  methods: {
    async selectLimit(limit) {
      await setLimitInsteadClosing({
        limit,
      });
      this.$logAnalyticEvent("mybank_red_reduce_limit_approved", {
        where: this.routeSrc,
        page_path: "/bank/red/reduce-limit",
        limit: `${limit}`,
        started_from: "",
      });
      this.$router.replace(`/bank/red/limits/success?limit=${limit}`);
    },
    onLimitSwitch(index) {
      this.selectedLimit = index;
      this.$logAnalyticEvent("mybank_red_reduce_limit_selected", {
        where: this.routeSrc,
        page_path: "/bank/red/reduce-limit",
        limit: `${this.limits[index]}`,
        started_from: "",
      });
    },
    setLimit() {
      const limitAmount = this.limits[this.selectedLimit];
      this.selectLimit(limitAmount);
    },
    async redirectToClose() {
      const closeDetails = await getDetailsOnClose();
      this.$logAnalyticEvent("mybank_red_reduce_limit_cancel", {
        where: this.routeSrc,
        page_path: "/bank/red/reduce-limit",
        started_from: "",
      });
      if (closeDetails?.balance > 0) {
        this.$router.replace("/bank/red/close/transfer");
        return;
      }
      this.$router.replace("/bank/red/close");
    },
  },
};
</script>

<style lang="scss" scoped>
.reject-btn {
  margin-top: -15px;
}

.select-limit {
  &__radio {
    padding: 10px 15px 15px;

    &_title {
      color: #4a4a4a;
      background-color: white;
      text-align: left;
      font-family: Roboto-Bold;
      font-size: 20px;
      padding: 20px 15px 15px;
    }
  }
}
</style>
